export default __webpack_public_path__ + "static/media/user.04ffa081.png";